import React from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Surface, { type SurfaceProps } from '../../../Surface';
import s from './ModalBody.scss';

export interface Props extends Omit<SurfaceProps, 'tag' | 'type'> {
  children: React.ReactNode;

  /**
   * Will resize the modal content to take up the whole screen.
   */
  isFullscreen?: boolean;

  surfaceType: SurfaceProps['type'];
  className?: string;
}

/**
 * The body of a modal that should rest within an {@link ModalRoot} component. This provides sizing logic for
 * full screening the modal and a {@link Surface} for standard styling.
 */
const ModalBody = React.forwardRef<HTMLDivElement, Props>(
  ({ isFullscreen, children, surfaceType, className, ...rest }, ref) => {
    return (
      <Surface
        tag={Section}
        type={surfaceType}
        className={c(s['root'], isFullscreen && s['fullscreen'], className)}
        ref={ref}
        {...rest}
      >
        {children}
      </Surface>
    );
  }
);

ModalBody.displayName = 'ModalBody';

export default ModalBody;
